module.exports = __webpack_public_path__ + "media/ping.92aa6cac.wav";